import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=af4300fe&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af4300fe')) {
      api.createRecord('af4300fe', component.options)
    } else {
      api.reload('af4300fe', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=af4300fe&", function () {
      api.rerender('af4300fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hL6y5aYIk7wu/JS/ImageCarousel.vue"
export default component.exports